import React from "react";
import { useLoaderData } from "react-router";
import TwoColumnLayout from "layout/TwoColumnLayout";
import DocumentV1FromShowSection from "./DocumentV1FromShowSection";
import GeneralOptionsPanel from "components/optionspanel/GeneralOptionsPanel";

export const DocumentV1FromShowApp = () => {
  const viewModel = useLoaderData<server.viewmodel.ShowNewDocumentFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <DocumentV1FromShowSection viewModel={viewModel} />
    </TwoColumnLayout.LeftColumn>
    <TwoColumnLayout.RightColumn>
      <GeneralOptionsPanel
        data={viewModel.optionsPanel}
        links={[{ text: RESX.Buttons.ListView, visible: true, href: viewModel.listUrl }]}
      />
    </TwoColumnLayout.RightColumn>
  </TwoColumnLayout>
};

export default DocumentV1FromShowApp;
